module.exports = __webpack_public_path__ + "img/complete.c581c68d.png";